import {BaseAttribute} from "@/pages/AppPages/Events/attribute";

export const HAIR_TYPE = {
    1: 'Короткая',
    2: 'Средняя',
    3: 'Длинная'
}

export const EARS_CROP = {
    1: 'Купированы',
    2: 'Не купированы'
}

export const TAIL_CROP = {
    1: 'Купирован',
    2: 'Не купирован'
}

export const GENDER = {
    0: 'Не указан',
    1: 'Самец',
    2: 'Самка'
}

export class InitialEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams)
        this.inspectionDate = null;
        this.age = null;
        this.weight = null;
        this.height = null;
        this.color = null;
        this.hairType = 1;
        this.earCrop = 2;
        this.tailCrop = 2;
        this.distinctive = null;
        this.ownerSigns = null;
        this.labelId = null;
        this.chipId = null;
        this.results = null;
        this.vetHelp = null;
        this.conclusion = null;
        this.vetSpecialist = null;
        this.gender = 0;
        this.genderName = null;

        this.earlySterilization = false;
        this.earlySterilizationDate = null;
        this.repeatedCatching = false;
        this.comment = null;

        if (initObjectParams && initObjectParams.chipId) {
            this.chipId = initObjectParams.chipId;
        }

        if (initObjectParams && initObjectParams.labelId) {
            this.labelId = initObjectParams.labelId;
        }

        this.hairTypeText = null;
        this.earCropText = null;
        this.tailCropText = null;

        this.colorGroups = null;
        this.colorGroupList = [];
        this.colorGroupObjects = [];
    }

    static get modelName() {
        return 'ClinicalEvent'
    }

    static get validations() {
        return {
            inspectionDate: {},
            age: {},
            weight: {},
            height: {},
            colorGroups: {},
            colorGroupList: {},
            color: {},
            hairType: {},
            earCrop: {},
            tailCrop: {},
            distinctive: {},
            ownerSigns: {},
            labelId: {},
            chipId: {},
            results: {},
            vetHelp: {},
            conclusion: {},
            vetSpecialist: {},
            gender: {},
            earlySterilization: {},
            earlySterilizationDate: {},
            repeatedCatching: {},
            comment: {}
        }
    }

    static get validationFieldLabels() {
        return {
            inspectionDate: 'Дата осмотра',
            age: 'Возраст',
            weight: 'Вес',
            height: 'Высота в холке',
            colorGroupList: 'Группы окрасов',
            color: 'Окрас',
            hairType: 'Шерсть',
            earCrop: 'Уши',
            tailCrop: 'Хвост',
            distinctive: 'Особые приметы',
            ownerSigns: 'Признаки владельца',
            labelId: 'Бирка',
            chipId: 'Чип',
            results: 'Результаты',
            vetHelp: 'Ветеринарная помощь',
            conclusion: 'Заключение',
            vetSpecialist: 'Ветеринарный врач',
            gender: 'Пол',
            earlySterilization: 'Стерилизовано ранее',
            earlySterilizationDate: 'Дата стерилизации',
            repeatedCatching: 'Отловлено повторно',
            comment: 'Комментарий'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    get colorGroupNames() {
        return this.colorGroupObjects.map(x => x.name)
    }

    applyData(data) {
        this.age = data['age'];
        this.weight = data['weight'];
        this.height = data['height'];
        this.color = data['color'];
        this.hairType = data['hairType'];
        this.earCrop = data['earCrop'];
        this.tailCrop = data['tailCrop'];
        this.distinctive = data['distinctive'];
        this.ownerSigns = data['ownerSigns'];
        this.labelId = data['labelId'];
        this.chipId = data['chipId'];
        this.results = data['results'];
        this.vetHelp = data['vetHelp'];
        this.conclusion = data['conclusion'];
        this.vetSpecialist = data['vetSpecialist'];
        this.gender = data['gender'];

        this.earlySterilization = data['earlySterilization'];
        this.earlySterilizationDate = data['earlySterilizationDate'];
        this.repeatedCatching = data['repeatedCatching'];
        this.comment = data['comment'];

        this.hairTypeText = HAIR_TYPE[this.hairType];
        this.earCropText = EARS_CROP[this.earCrop];
        this.tailCropText = TAIL_CROP[this.tailCrop];
        this.genderName = GENDER[this.gender];

        this.colorGroups = data['colorGroups']
        this.colorGroupList = data['colorGroupList']
        this.colorGroupObjects = data['colorGroupObjects']
    }

}